(function () {
    'use strict';

    angular
        .module('sodNotificationCenter')
        .directive('notificationCenterBadge', notificationCenterBadge);

    function notificationCenterBadge() {
        return {
            restrict: 'E',
            controller: notificationCenterBadgeCtrl,
            controllerAs: 'nc',
            bindToController: true,
            scope: {},
            template: '<span ng-bind="nc.total" style="color:white"></span>'
        };
    }

    function notificationCenterBadgeCtrl(NotificationCenterService, $scope) {
        var nc = this;
        this.$onInit = function() {
            nc.total = NotificationCenterService.getTotal();

            $scope.$watch(
                function() { return NotificationCenterService.getUpdatedTime() },
                function() {
                    nc.total = NotificationCenterService.getTotal();
                }
            );
        }
    }
})();